<template>
  <div class="conteudoInterno" id="diretor-operacoes">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
    </div>
    <header class="headerSec">
      <h2>Análise do nosso diretor de operações</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
        <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
      </div> 
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol ubcBlueBack"></span> 
      </div> 
    </section>
    <section class="sectionRow top65">
      <div class="col40ponto4">
        <img title="Fábio Geovane" alt="Fábio Geovane" src="../assets/imgs/fabio_geovane.jpg" />
      </div>
      <div class="col49">
        <p>O ano de 2024 foi, mais uma vez, de superação e recordes históricos, tanto na distribuição quanto nos cadastros de obras, fonogramas, audiovisuais e titulares. Ao mesmo tempo, foi um ano de muito trabalho para que pudéssemos encontrar maneiras de combater as tentativas de fraudes que o sistema de gestão coletiva mundial vem enfrentando.</p>

        <p>O volume gigantesco de dados que tratamos nos obriga a investir em tecnologia para atender a esse volume — e para que possamos identificar possíveis inconsistências ou tentativas de fraudes. A UBC implementou melhorias em sistemas e passou a exigir mais informações e documentação que validem os dados enviados a nós. Continuaremos investindo e trabalhando para que somente os reais proprietários cadastrem e usufruam dos rendimentos de suas obras.</p>

        <p>Para termos uma ideia, a UBC cadastrou em 2024 2,8 milhões de obras, 1,4 milhão de fonogramas e cerca de 22 mil audiovisuais, e todo esse volume foi um recorde no input de informações. Além disso, outro recorde foi na distribuição de cerca de R$ 930 milhões em direitos autorais, incluindo execução pública nacional e estrangeira e o direito fonomecânico. Isso representou um crescimento de 17% em comparação com 2023.</p>

        <h4 class="h4Destaque ubcBlue sanukBlack top32">“O volume gigantesco de dados que tratamos nos obriga a investir em tecnologia”</h4>
        <br />

        <p>Seguimos com nosso compromisso no investimento em tecnologia e, em 2024, iniciamos o desenvolvimento de sistemas que usarão inteligência artificial para que possamos continuar a entregar um serviço de qualidade aos nossos titulares e parceiros. Fiquem atentos, teremos novidades em 2025!</p>

        <p>Em 2024, o mercado da música esteve muito aquecido, principalmente nos shows, com crescimento de 33% na comparação com 2023; e streaming de áudio e audiovisual, com expansões de, respectivamente, 17% e 22%. A expectativa para 2025 é de um crescimento menor, porém ainda com grandes volumes.</p>
        
        <p>Por fim, outro tema constante em 2024 foi uso da inteligência artificial generativa, e a UBC está acompanhando toda essa questão, tanto na parte da discussão e proteção do direito como no preparo dos sistemas para lidar com essa nova realidade. Estamos certos de que se trata de uma nova revolução tecnológica — e na vida daqueles que produzem e vivem da música —, mas estamos preparados para lidar com ela.</p>

        <p>Este é nosso compromisso!</p>

        <br />
        <p class="ubcBlue sanukBold">Fabio Geovane</p>
      </div>
    </section>  
    </div>
  </div>
  </template>
  
  <script>
  import { ShareFunctions } from '../assets/js/functions.js'

  export default {
    name: 'AnaliseDiretorDeOperacoes',
    props:['clicked'],
  
    data() {
      return{
        setaScrollState: false,
      }
    },
    mounted() {
      const conteudo = document.querySelector('#diretor-operacoes')
      conteudo.addEventListener('scroll', ShareFunctions.headerScroll)
    },
    methods: {
      goNext: function(){
        this.$emit("go-next");
      },
      goBack: function(){
        this.$emit("go-back");
      }, 
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .col40ponto4 img{
    width: 100%;
    max-width: 481px;
  }

  @media screen and ( max-width: 800px ) {
    .col40ponto4 img{
      margin-bottom: 32px;
    }
  }
  </style>